import React, { useState, useEffect } from 'react';
import useAuth from '../../hooks/useAuth';
import StudentListPage from './StudentListPage';
import DashboardContent from '../../context/teacher/DashboardContent';
import ProfileContent from '../../context/teacher/ProfileContent';
import SettingsContent from '../../context/teacher/SettingsContent';
import LessonsPage from './LessonsPage';
import EarningsPage from './EarningsPage';

export default function TeacherPanel() {
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [loading, setLoading] = useState(true);
  const { user, logout, updateProfile, changePassword } = useAuth();

  useEffect(() => {
    // Kullanıcı bilgileri zaten AuthContext'ten geliyor
    if (user) {
      setLoading(false);
    }
  }, [user]);

  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <DashboardContent teacherData={user} setCurrentPage={setCurrentPage} />;
      case 'students':
        return <StudentListPage />;
      case 'lessons':
        return <LessonsPage />;
      case 'earnings':
        return <EarningsPage />;
      case 'profile':
        return <ProfileContent teacherData={user} />;
      case 'settings':
        return <SettingsContent />;
      default:
        return <DashboardContent teacherData={user} />;
    }
  };

  if (loading || !user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex">
      {/* Sidebar */}
      <div className="w-64 bg-white shadow-lg fixed h-full">
        <div className="p-6 border-b">
          <h2 className="text-xl font-bold text-gray-800">Öğretmen Paneli</h2>
          <p className="text-sm text-gray-600 mt-1">{user?.adi}</p>
        </div>
        
        <nav className="p-4">
          <SidebarButton
            icon="🏠"
            text="Ana Sayfa"
            active={currentPage === 'dashboard'}
            onClick={() => setCurrentPage('dashboard')}
          />
          
          <SidebarButton
            icon="👥"
            text="Öğrencilerim"
            active={currentPage === 'students'}
            onClick={() => setCurrentPage('students')}
          />
          
          <SidebarButton
            icon="📚"
            text="Derslerim"
            active={currentPage === 'lessons'}
            onClick={() => setCurrentPage('lessons')}
          />
          
          <SidebarButton
            icon="💰"
            text="Hakediş"
            active={currentPage === 'earnings'}
            onClick={() => setCurrentPage('earnings')}
          />
          
          <SidebarButton
            icon="👤"
            text="Profilim"
            active={currentPage === 'profile'}
            onClick={() => setCurrentPage('profile')}
          />
          
          <SidebarButton
            icon="⚙️"
            text="Ayarlar"
            active={currentPage === 'settings'}
            onClick={() => setCurrentPage('settings')}
          />
          
          <hr className="my-4 border-gray-200" />
          
          <button
            onClick={logout}
            className="w-full text-left px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 transition-colors flex items-center"
          >
            <span className="mr-3">🚪</span>
            Çıkış Yap
          </button>
        </nav>
      </div>

      {/* Main Content */}
      <div className="ml-64 flex-1">
        {renderPage()}
      </div>
    </div>
  );
}

// Sidebar Button Component
function SidebarButton({ icon, text, active, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`w-full text-left px-4 py-3 rounded-lg mb-2 transition-colors flex items-center ${
        active 
          ? 'bg-blue-600 text-white' 
          : 'hover:bg-gray-100 text-gray-700'
      }`}
    >
      <span className="mr-3 text-lg">{icon}</span>
      {text}
    </button>
  );
}